export const LinkHuggingFaceIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5554 3.38383C13.6293 2.30988 15.3705 2.30988 16.4445 3.38382L20.6161 7.5554C21.69 8.62934 21.69 10.3705 20.6161 11.4445L18.2803 13.7803C17.9874 14.0732 17.5125 14.0732 17.2196 13.7803C16.9267 13.4874 16.9267 13.0125 17.2196 12.7196L19.5554 10.3838C20.0436 9.89567 20.0436 9.10421 19.5554 8.61606L15.3838 4.44449C14.8957 3.95633 14.1042 3.95633 13.6161 4.44449L11.2803 6.78027C10.9874 7.07317 10.5125 7.07317 10.2196 6.78027C9.92672 6.48738 9.92672 6.01251 10.2196 5.71961L12.5554 3.38383ZM15.5303 8.46961C15.8232 8.76251 15.8232 9.23738 15.5303 9.53027L9.53027 15.5303C9.23738 15.8232 8.76251 15.8232 8.46961 15.5303C8.17672 15.2374 8.17672 14.7625 8.46961 14.4696L14.4696 8.46961C14.7625 8.17672 15.2374 8.17672 15.5303 8.46961ZM6.78027 10.2196C7.07316 10.5125 7.07316 10.9874 6.78027 11.2803L4.44449 13.6161C3.95633 14.1042 3.95633 14.8957 4.44449 15.3838L3.91416 15.9142L4.44449 15.3838L8.61606 19.5554C9.10421 20.0436 9.89567 20.0436 10.3838 19.5554L12.7196 17.2196C13.0125 16.9267 13.4874 16.9267 13.7803 17.2196C14.0732 17.5125 14.0732 17.9874 13.7803 18.2803L11.4445 20.6161C10.3705 21.69 8.62934 21.69 7.5554 20.6161L3.38383 16.4445C2.30988 15.3705 2.30988 13.6293 3.38383 12.5554L5.71961 10.2196C6.01251 9.92672 6.48738 9.92672 6.78027 10.2196Z"
        fill="#737373"
      />
    </svg>
  );
};
